import VictoryCeremonyTabContent from './VictoryCeremonyTabContent';

export default VictoryCeremonyTabContent;